import api from './axiosApi'
import type { ExportRead } from '@/types'
import type { CreateExportResponse } from '@/hooks/useExport'

/**
 * Create a new store model export job.
 * POST /admin/store-models/{modelId}/exports
 */
export async function createStoreModelExport(
  modelId: string
): Promise<CreateExportResponse> {
  const response = await api.post<CreateExportResponse>(
    `/admin/store-models/${modelId}/exports`
  )
  return response.data
}

/**
 * Get export status and download URL.
 * GET /exports/{exportId}
 */
export async function getStoreModelExport(
  exportId: string
): Promise<ExportRead> {
  const response = await api.get<ExportRead>(`/exports/${exportId}`)
  return response.data
}
